import React, {useState} from 'react';
import styles from './styles.module.scss';

const ShowPasswordIcon = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
            <path fillRule="evenodd" clipRule="evenodd" d="M3.40717 8.09467C5.19504 6.3068 8.00057 4.5 12 4.5C15.9994 4.5 18.805 6.3068 20.5928 8.09467C21.4846 8.98644 22.1276 9.87691 22.5487 10.5457C22.7597 10.8807 22.916 11.1618 23.0208 11.362C23.0733 11.4621 23.113 11.5422 23.1402 11.5988C23.1539 11.6272 23.1644 11.6497 23.1719 11.6659L23.1809 11.6855L23.1837 11.6917L23.1847 11.6938L23.185 11.6947C23.1852 11.6951 23.1854 11.6954 22.5 12C23.1854 12.3046 23.1852 12.3049 23.185 12.3053L23.1847 12.3062L23.1837 12.3083L23.1809 12.3145L23.1719 12.3341C23.1644 12.3503 23.1539 12.3728 23.1402 12.4012C23.113 12.4578 23.0733 12.5379 23.0208 12.638C22.916 12.8382 22.7597 13.1193 22.5487 13.4543C22.1276 14.1231 21.4846 15.0136 20.5928 15.9053C18.805 17.6932 15.9994 19.5 12 19.5C8.00057 19.5 5.19504 17.6932 3.40717 15.9053C2.5154 15.0136 1.87235 14.1231 1.45126 13.4543C1.24035 13.1193 1.08405 12.8382 0.979181 12.638C0.92672 12.5379 0.887047 12.4578 0.859771 12.4012C0.846131 12.3728 0.835583 12.3503 0.82808 12.3341L0.819098 12.3145L0.816307 12.3083L0.815334 12.3062L0.814952 12.3053C0.814791 12.3049 0.814641 12.3046 1.5 12C0.814641 11.6954 0.814791 11.6951 0.814952 11.6947L0.815334 11.6938L0.816307 11.6917L0.819098 11.6855L0.82808 11.6659C0.835583 11.6497 0.846131 11.6272 0.859771 11.5988C0.887047 11.5422 0.92672 11.4621 0.979181 11.362C1.08405 11.1618 1.24035 10.8807 1.45126 10.5457C1.87235 9.87691 2.5154 8.98644 3.40717 8.09467ZM1.5 12L0.814641 11.6954C0.728453 11.8893 0.728453 12.1107 0.814641 12.3046L1.5 12ZM2.33859 12C2.42682 12.1653 2.55353 12.3897 2.72061 12.6551C3.0964 13.2519 3.6721 14.0489 4.46783 14.8447C6.05496 16.4318 8.49943 18 12 18C15.5006 18 17.945 16.4318 19.5322 14.8447C20.3279 14.0489 20.9036 13.2519 21.2794 12.6551C21.4465 12.3897 21.5732 12.1653 21.6614 12C21.5732 11.8347 21.4465 11.6103 21.2794 11.3449C20.9036 10.7481 20.3279 9.95106 19.5322 9.15533C17.945 7.5682 15.5006 6 12 6C8.49943 6 6.05496 7.5682 4.46783 9.15533C3.6721 9.95106 3.0964 10.7481 2.72061 11.3449C2.55353 11.6103 2.42682 11.8347 2.33859 12ZM22.5 12L23.1854 12.3046C23.2715 12.1107 23.2715 11.8893 23.1854 11.6954L22.5 12Z" fill="#1E1E1E"/>
            <path fillRule="evenodd" clipRule="evenodd" d="M12 9C10.3431 9 9 10.3431 9 12C9 13.6569 10.3431 15 12 15C13.6569 15 15 13.6569 15 12C15 10.3431 13.6569 9 12 9ZM7.5 12C7.5 9.51472 9.51472 7.5 12 7.5C14.4853 7.5 16.5 9.51472 16.5 12C16.5 14.4853 14.4853 16.5 12 16.5C9.51472 16.5 7.5 14.4853 7.5 12Z" fill="#1E1E1E"/>
        </svg>
    );
}

const HidePasswordIcon = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
            <path d="M4.5 3.75L19.5 20.25" stroke="#1E1E1E" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
            <path d="M14.5218 14.7746C13.8337 15.405 12.9333 15.7532 12 15.7496C11.2431 15.7495 10.5039 15.5204 9.87972 15.0924C9.25549 14.6644 8.77539 14.0575 8.50253 13.3515C8.22967 12.6455 8.17683 11.8735 8.35095 11.1369C8.52507 10.4003 8.918 9.73369 9.47809 9.22461" stroke="#1E1E1E" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
            <path d="M6.9375 6.43164C3.1125 8.36289 1.5 12.0004 1.5 12.0004C1.5 12.0004 4.5 18.7504 12 18.7504C13.7574 18.7647 15.4929 18.3598 17.0625 17.5691" stroke="#1E1E1E" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
            <path d="M19.5563 15.8531C20.8506 14.6954 21.6862 13.4587 22.125 12.7073C22.3791 12.2723 22.5001 12 22.5001 12C22.5001 12 22.3791 11.7278 22.125 11.2928C21.1137 9.56127 17.994 5.25002 12.0001 5.25002C11.3499 5.24874 10.7007 5.30205 10.0594 5.4094" stroke="#1E1E1E" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
            <path d="M12.7031 8.31543C13.5006 8.46653 14.2273 8.87293 14.7735 9.47329C15.3198 10.0736 15.6559 10.8354 15.7313 11.6436" stroke="#1E1E1E" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
        </svg>
    )
}

const DisabledIcon = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="25" height="24" viewBox="0 0 25 24" fill="none">
            <path fillRule="evenodd" clipRule="evenodd" d="M3.5 9C3.5 8.17157 4.17157 7.5 5 7.5H20C20.8284 7.5 21.5 8.17157 21.5 9V19.5C21.5 20.3284 20.8284 21 20 21H5C4.17157 21 3.5 20.3284 3.5 19.5V9ZM20 9H5V19.5H20V9Z" fill="#1E1E1E"/>
            <path fillRule="evenodd" clipRule="evenodd" d="M12.5 2.25C11.8038 2.25 11.1361 2.52656 10.6438 3.01884C10.1516 3.51113 9.875 4.17881 9.875 4.875V8.25C9.875 8.66421 9.53921 9 9.125 9C8.71079 9 8.375 8.66421 8.375 8.25V4.875C8.375 3.78098 8.8096 2.73177 9.58318 1.95818C10.3568 1.1846 11.406 0.75 12.5 0.75C13.594 0.75 14.6432 1.1846 15.4168 1.95818C16.1904 2.73177 16.625 3.78098 16.625 4.875V8.25C16.625 8.66421 16.2892 9 15.875 9C15.4608 9 15.125 8.66421 15.125 8.25V4.875C15.125 4.17881 14.8484 3.51113 14.3562 3.01884C13.8639 2.52656 13.1962 2.25 12.5 2.25Z" fill="#1E1E1E"/>
            <path d="M12.5 15.375C13.1213 15.375 13.625 14.8713 13.625 14.25C13.625 13.6287 13.1213 13.125 12.5 13.125C11.8787 13.125 11.375 13.6287 11.375 14.25C11.375 14.8713 11.8787 15.375 12.5 15.375Z" fill="#1E1E1E"/>
        </svg>
    )
}

interface IProps {
    value: string;
    onChange: (e:React.ChangeEvent<HTMLInputElement>) => void;
    placeholder?: string;
    id?: string;
    type?: string;
    errorText?: string;
    disabled?: boolean;
    onBlur?: (e:React.FocusEvent<HTMLInputElement>) => void;
}

const Input = ({value, onChange, placeholder, id, type='text', errorText, disabled=false, onBlur}:IProps) => {
    const [isFocused, setIsFocused] = useState(false);
    const [isShowPassword, setIsShowPassword] = useState(true);

    const handleFocus = () => setIsFocused(true);
    const handleBlur = (e:React.FocusEvent<HTMLInputElement>) => {
        setIsFocused(false)

        if(onBlur) {
            onBlur(e);
        }
    };
    const toggleShowPassword = () => setIsShowPassword((prev) => !prev);

    const isShowTitle = () => isFocused || value.length !== 0;

    const generateClassName = ():string => {
        return `
        ${styles.input__input}
        ${isShowTitle() ? styles.input__input_active : ''}
        ${errorText ? styles.input__error : ''}
        ${disabled ? styles.input__disabled : ''}
        `
    };

    return (
        <>
            <div className={styles.input}>
                {isShowTitle() ? <span className={styles.input__title}>{placeholder}</span> : null}
                {type === 'password' ? (
                    <button
                        className={styles.input__password}
                        onClick={toggleShowPassword}
                    >
                        {isShowPassword ? <ShowPasswordIcon /> : <HidePasswordIcon />}
                    </button>
                ) : null}
                <input
                    onFocus={handleFocus}
                    onBlur={handleBlur}
                    type={isShowPassword ? type : 'text'}
                    id={id}
                    className={generateClassName()}
                    placeholder={placeholder}
                    value={value}
                    onChange={onChange}
                    disabled={disabled}
                />
                {disabled ? (
                    <span className={styles.input__disabled_icon}>
                        <DisabledIcon/>
                    </span>
                ) : null}
                {errorText ? (
                    <span className={styles.input__error_text}>
                        {errorText}
                    </span>
                ) : null}
            </div>
        </>
    );
};

export default Input;
